export default {
  hardcodedPath: process.env.VUE_APP_PATH,
};
